function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { array, isString } from 'vega-util';
import * as log from '../../log';
import { isLookupData, isLookupSelection } from '../../transform';
import { duplicate, hash as _hash, varName } from '../../util';
import { DataFlowNode, OutputNode } from './dataflow';
import { findSource } from './parse';
import { SourceNode } from './source';
import { DataSourceType } from '../../data';
export var LookupNode = /*#__PURE__*/function (_DataFlowNode) {
  function LookupNode(parent, transform, secondary) {
    var _this;
    _classCallCheck(this, LookupNode);
    _this = _callSuper(this, LookupNode, [parent]);
    _this.transform = transform;
    _this.secondary = secondary;
    return _this;
  }
  _inherits(LookupNode, _DataFlowNode);
  return _createClass(LookupNode, [{
    key: "clone",
    value: function clone() {
      return new LookupNode(null, duplicate(this.transform), this.secondary);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set([this.transform.lookup]);
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as ? array(this.transform.as) : this.transform.from.fields);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Lookup ".concat(_hash({
        transform: this.transform,
        secondary: this.secondary
      }));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var foreign;
      if (this.transform.from.fields) {
        // lookup a few fields and add create a flat output
        foreign = _objectSpread({
          values: this.transform.from.fields
        }, this.transform.as ? {
          as: array(this.transform.as)
        } : {});
      } else {
        // lookup full record and nest it
        var asName = this.transform.as;
        if (!isString(asName)) {
          log.warn(log.message.NO_FIELDS_NEEDS_AS);
          asName = '_lookup';
        }
        foreign = {
          as: [asName]
        };
      }
      return _objectSpread(_objectSpread({
        type: 'lookup',
        from: this.secondary,
        key: this.transform.from.key,
        fields: [this.transform.lookup]
      }, foreign), this.transform.default ? {
        default: this.transform.default
      } : {});
    }
  }], [{
    key: "make",
    value: function make(parent, model, transform, counter) {
      var sources = model.component.data.sources;
      var _transform = transform,
        from = _transform.from;
      var fromOutputNode = null;
      if (isLookupData(from)) {
        var fromSource = findSource(from.data, sources);
        if (!fromSource) {
          fromSource = new SourceNode(from.data);
          sources.push(fromSource);
        }
        var fromOutputName = model.getName("lookup_".concat(counter));
        fromOutputNode = new OutputNode(fromSource, fromOutputName, DataSourceType.Lookup, model.component.data.outputNodeRefCounts);
        model.component.data.outputNodes[fromOutputName] = fromOutputNode;
      } else if (isLookupSelection(from)) {
        var selName = from.param;
        transform = _objectSpread({
          as: selName
        }, transform);
        var selCmpt;
        try {
          selCmpt = model.getSelectionComponent(varName(selName), selName);
        } catch (e) {
          throw new Error(log.message.cannotLookupVariableParameter(selName));
        }
        fromOutputNode = selCmpt.materialized;
        if (!fromOutputNode) {
          throw new Error(log.message.noSameUnitLookup(selName));
        }
      }
      return new LookupNode(parent, transform, fromOutputNode.getSource());
    }
  }]);
}(DataFlowNode);